import { isTextPolicyCode } from '@instanexus/contracts';
const KEYS = {
    TEXT_REQUIRED: 'common:textPolicy.required',
    TEXT_TOO_LONG: 'common:textPolicy.tooLong',
    TEXT_EMOJI_NOT_ALLOWED: 'common:textPolicy.emojiNotAllowed',
    TEXT_INVALID_CHARS: 'common:textPolicy.invalidChars',
    NAME_INVALID: 'common:textPolicy.nameInvalid',
    NAME_NEEDS_FIRST_AND_LAST: 'common:textPolicy.nameNeedsFirstAndLast',
};
/**
 * The free-text policy's issue `message` is a machine code (`packages/contracts/src/text-policy.ts`).
 * This turns one into the user's-language sentence; `null` when `original` is not a policy code
 * (so a caller falls through to its own per-field copy).
 *
 * `issueCode` is the zod issue code the form resolver reports. Required (`too_small`) and too long
 * (`too_big`) are NATIVE zod issues that every form already words per field ("Enter the visitor's
 * first name.", "Use 100 characters or fewer."), so this yields to that copy and only answers for
 * `custom` issues — the character rules and the kiosk name rules. The generic required / too-long
 * keys remain for callers with no field-specific copy: pass `'custom'` to force the mapping.
 * `TEXT_TOO_LONG` needs the limit, so pass `max` when the caller knows it.
 */
export function textPolicyMessage(t, issueCode, original, max) {
    if (issueCode !== 'custom' || !isTextPolicyCode(original))
        return null;
    return t(KEYS[original], max === undefined ? undefined : { max });
}
//# sourceMappingURL=text-policy-message.js.map